<script>
    export let style;
    export let disabled;
    export let className;

</script>


<button on:click {style} {disabled} class={className}>
    <slot />
</button>

<style>
    .call-btn-bg-color {
        background: linear-gradient(45deg, color-mix(in srgb, var(--primary-bg-color) 50%, white), var(--primary-bg-color));
        border: 1.5px var(--primary-bg-color) solid;
    }
</style>
